import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getSocialMediaProviderProfiles } from "./action";

export const socialMediaProviderProfileAdapter = createEntityAdapter({
  selectId: (entity) => entity.profileKey,
});

const initialState = socialMediaProviderProfileAdapter.getInitialState({
  loading: false,
  error: null,
});

export const activeSocialAccounts = createSlice({
  name: "ayrshareUser",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSocialMediaProviderProfiles.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSocialMediaProviderProfiles.fulfilled, (state, action) => {
      if (action?.payload?.data) {
        socialMediaProviderProfileAdapter.setAll(state, action?.payload?.data);
      } else {
        socialMediaProviderProfileAdapter.removeAll(state);
      }
      state.loading = false;
    });
  },
});

export default activeSocialAccounts.reducer;
